import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import type { QueryOpts } from "./useTrackingEvents";

export interface UserEventBreakdown {
	event_name: string;
	count: number;
	last_seen_at: string;
}

export interface UserEngagement {
	user_id: string;
	full_name: string | null;
	job_title: string | null;
	org_team_level_one: string | null;
	from: string;
	to: string;
	total_events: number;
	first_seen_in_window: string | null;
	last_seen_in_window: string | null;
	event_breakdown: UserEventBreakdown[];
}

export interface UserEngagementArgs {
	userId: string;
	from: Date;
	to: Date;
}

const fetchEngagement = async (
	args: UserEngagementArgs
): Promise<UserEngagement> => {
	const { data } = await cmsClient.get<UserEngagement>(
		`/tracking/users/${encodeURIComponent(args.userId)}/engagement/`,
		{
			params: {
				from: args.from.toISOString(),
				to: args.to.toISOString()
			}
		}
	);
	return data;
};

const useTrackingUserEngagement = (
	args: UserEngagementArgs,
	options?: QueryOpts
) =>
	useQuery(
		[
			"tracking",
			"user-engagement",
			args.userId,
			args.from.toISOString(),
			args.to.toISOString()
		],
		() => fetchEngagement(args),
		{ enabled: !!args.userId && (options?.enabled ?? true) }
	);

export default useTrackingUserEngagement;
